import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreateRequestComponent } from './create-request.component';
import { PrimengModule } from '../../shared/primeng-module/primeng.module';
import { GeneralModule } from '../general/general.module';

@NgModule({
  declarations: [
    CreateRequestComponent
  ],
  imports: [
    CommonModule,
    PrimengModule,
    GeneralModule
  ],
  exports: [
    CreateRequestComponent
  ]
})
export class SalesCreateRequestModule { }